import { useCurrentUserQuery } from "@/api/queries/UserQueries";
import NotFound from "@/pages/NotFound";
import Loading from "@/components/loading/Loading";
import { Outlet } from "react-router-dom";

const AdminRoutes = () => {
    const { data: currentUser, isLoading, error } = useCurrentUserQuery();

    if (isLoading) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <Loading size="large" />
            </div>
        );
    }

    if (error || !currentUser) {
        return <NotFound />;
    }

    // Check if user has admin role
    if (currentUser.role !== "admin") {
        return <NotFound />;
    }

    return <Outlet />;
};

export default AdminRoutes;
